/*
*
* File JS componente Hero Home
*
*/

// IMPORT MODULES
//--------------------------------------------------------------------//
// Nulla al momento


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//
import './video-player.scss';


/**
*	Video Player
*
*	@version  0.0.1
*	@author   Ignazio Stagnitta - IM*MEDIA
*
*/
class videoPlayer
{
    /**
    *   Inizializziamo i parametri
    *
    *   @return {void}
    */
    constructor()
    {
        this.videos = document.querySelectorAll('[data-video-player]');

        this.player = null;
        this.video = null;
        this.playerContent = null;

        this.init();
    }

    /**
    *   E tutto ebbe inizio!
    *
    *   @return {void}
    */
    init()
    {
        if( !this.videos ) return;

        this.addPlayerIntoDom();
        this.setEvents();
    }

    /**
    *   setEvents
    *   Attiviamo l'evento click per mostrare il video in una modale
    *   Attiviamo l'evento click al pulsante chiudi
    *
    *   @return {void}
    */
    setEvents()
    {
        /* Al click sul link video
        ----------------------------------------------------------------------*/
        this.videos.forEach((video) =>
        {
            video.addEventListener('click', e=>
            {
                e.preventDefault();
                this.addVideoIntoPlayer(video.dataset.videoPlayer);
            });
        });

        /* Al click sul chiudi
        ----------------------------------------------------------------------*/
        const close = this.player.querySelector('.video-player__close');
        if( close !== null )
        {
            close.addEventListener('click', (e)=>
            {
                this.closePlayer();
            });
        }

        /* Premendo esc chiudiamo la modale
        ----------------------------------------------------------------------*/
        document.addEventListener('keyup', (e)=>
        {
            if(e.key === "Escape")
            {
                if( this.player.classList.contains('is-open') )
                {
                    this.closePlayer();
                }
            }
        });
    }

    /**
    *  addVideoIntoPlayer
    *  Aggiungiamo il video al player per la visualizzazione
    *
    *   @param  {string} src url del video
    *
    *   @return {void}
    */
    addVideoIntoPlayer(src)
    {
        const html = `<video controls class="loading">
                          <source src="${src}" type="video/mp4">
                          Your browser does not support the video tag.
                      </video>`;

        this.playerContent.innerHTML = html;
        this.video = this.playerContent.querySelector('video');

        this.openPlayer();
        this.video.classList.add('attached');

        this.video.addEventListener("canplay", e=>
        {
            this.video.play();
            this.video.classList.remove('loading');
            this.video.classList.add('play');
        });
    }

    /**
    *   addPlayerIntoDom
    *   Inseriamo nel dom l'overlay per il play del video
    *
    *   @return {void}
    */
    addPlayerIntoDom()
    {
        const innerHtml = '<div class="video-player__content">'
                        + '</div>'
                        + '<span class="video-player__close"></span>';

        this.player = document.createElement('div');
        this.player.classList.add('video-player');
        this.player.innerHTML = innerHtml;

        this.playerContent = this.player.querySelector('.video-player__content');

        const body = document.querySelector('body');
        body.appendChild(this.player);
    }

    /**
    *   openPlayer
    *   Inseriamo la classe is-open al player
    *
    *   @return {void}
    */
    openPlayer()
    {
        this.player.classList.add('is-open');
    }

    /**
    *   closePlayer
    *   Eliminiamo la classe is-open al player e mettiamo il video in pausa
    *
    *   @return {void}
    */
    closePlayer()
    {
        this.video.pause();
        this.player.classList.remove('is-open');
    }
}

const vp = new videoPlayer();

/**
*   Esportiamo la funzione che ritorna il costruttore
*/
//export default videoPlayer;